<template>
  <drag tag="tr" v-bind:class="{ tr: true, 'has-issues': isDisabled }" :transfer-data="run" :draggable="!inMap"
    @dragstart="dragFn(true)" @dragend="dragFn(false)" v-if="!isMobile">
    <!-- <div slot="image" class="dragslot">Run {{ run.id }}</div> -->
    <td class="check">
      <input type="radio" v-model="selected" :value="run.id" @click="select(run.id)" />
      <div class="timer" :data-time="sendTimer" v-show="timeLeft">{{ timeLeft }}</div>
    </td>
    <td class="map-button pkg-map">
      <a @click="toggleInMap" :class="{ selected: inMap }">
        <i class="fas fa-map-marker-alt"></i>
        <!-- <i class="fas fa-paper-plane"></i> -->
      </a>
    </td>
    <td class="ids">
      <a v-for="(id, x) in run.rsvpIDs" :href="`/#/reservation/${id}`" target="_blank" :key="`x${x}`" class="rsvp-id">{{id}}</a>
    </td>
    <td class="date">{{ run.pickupDate }}</td>
    <td class="date2">{{ run.lastDropoff }}</td>
    <td class="locs pickup">{{ getAddress(run.pickup) }}</td>
    <td class="locs dropoff">{{ getAddress(run.dropoff) }}</td>
    <td class="driver-payment">${{ parseFloat(run.driverPayment.toFixed(2)) }}</td>
    <td class="pax">{{ run.pax.join('/') }}</td>
    <td class="service">
      <span class="service-type" v-for="(service, n) in run.services"
        :style="{background: service.color}" :key="`n${n}`">{{ service.name }}</span>
    </td>
    <td class="action">
      <div class="button cta break xsmall" @click="breakRun(run.id)">Break</div>
    </td>
  </drag>
  <div v-else class="table-card">
      <div class="row-1">
        <div>
          <input type="radio" v-model="selected" :value="run.id" />
          <a v-for="(id, x) in run.rsvpIDs" :href="`/#/reservation/${id}`" target="_blank" :key="`x${x}`" class="rsvp-id">{{id}}</a>
          <span class="service-type" v-for="(service, n) in run.services"
            :style="{background: service.color}" :key="`n${n}`">{{ service.name }}</span>
        </div>
        <div class="map-button"  @click="toggleInMap">
          <a href="javascript:;" :class="{selected: inMap}">
            <i class="fas fa-map-marker-alt"></i>
          </a>
        </div>
      </div>
      <div>
        <div>Pickup Time: {{ run.pickupDate }}</div>
      </div>
      <div v-if="run.flightInfo">
        <a @click="showFlightInfo(rsvp)">{{run.flightInfo.airline}} {{run.flightInfo.flightNo}}</a>
        <img src="/assets/img/departure.png" v-if="run.flightInfo.isDeparture" />
        <img src="/assets/img/arrival.png" v-else />
      </div>
      <div class="row-4">
        <div class="pickup">
          <i class="fas fa-map-marker-alt icon"></i>
          {{ getAddress(run.pickup) }}
        </div>
      </div>
      <div class="row-5">
        <div class="dropoff">
          <i class="fas fa-location-arrow icon"></i>
          <span>{{ getAddress(run.dropoff) }}</span>
        </div>
      </div>
      <div>
        <div>Driver Payment: ${{ parseFloat(run.driverPayment.toFixed(2)) }}</div>
      </div>
      <div v-if="run.pax">
        PAX: {{run.pax}}
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import request from 'browser-request'

export default {
  name: 'runs-table',
  props: ['run', 'isMobile'],
  data () {
    return {
      timeLeft: '',
      timerDelay: '',
      isDisabled: false
    }
  },
  computed: {
    runs () { return this.$store.state.runs },
    airports () { return this.$store.state.airports.list },
    selected: {
      get () { return this.runs.selected },
      set (x) { this.$store.commit('runs/setRunsDetails', {selected: x}) }
    },
    inMap () {
      let mapItems = this.$store.state.runs.dropzone.items
      let item = mapItems.filter(mapItem => mapItem.runId === this.run.id)
      return item.length > 0
    },
    dropzoneItems () { return this.$store.state.runs.dropzone.items },
    // hasIssues () { return false },
    sendTimer () {
      let timer = this.runs.other.sendTimer[`a${this.run.id}`]
      if (timer) {
        if (this.timerDelay) clearTimeout(this.timerDelay)
        if (timer != 0) this.startCountdown()
        this.timeLeft = `Waiting for reply.. (${timer})`
      }
      return timer ? timer : 0
    }
  },
  methods: {
    select (x) {
      if (this.selected == x) {
        this.selected = null
        return
      }

      // this.$store.commit('runs/clearDropzone')
      // this.toggleInMap()
    },
    dragFn (showDropzone) {
      this.$store.commit('runs/setDropzoneData', {show: showDropzone})
    },
    getAddress (loc) {
      let index = this.airports.findIndex(x => x.geofenceId === loc.geofenceId)
      if (index > -1) return this.airports[index].title
      return loc.title
    },
    toggleInMap () {
      let self = this
      self.$store.commit('runs/setRunsInMap', self.run.id)
      if (self.inMap) {
        self.$store.commit('runs/removeDropzoneItems', self.run)
        return
      }
      let item = self.run
      for (let i = 0; i < item.rsvps.length; i++) {
        let rsvp = item.rsvps[i]
        rsvp['runId'] = item.id
        self.$store.commit('runs/addDropzoneItem', rsvp)
      }
    },
    breakRun (id) {
      this.$store.commit('runs/setRunsDetails', {breakIds: [id]})
      this.$store.commit('routing/setConfirmationModal', {
        show: true,
        title: 'Confirm Break Run',
        message: 'Are you sure you want to break this run?',
        action: 'BREAK_RUN'
      })
      this.$store.commit('routing/showRoutingModal')
    },
    startCountdown () {
      let self = this
      let x = parseInt(this.runs.other.sendTimer[`a${this.run.id}`] || 0)
      if (self.timerDelay) clearTimeout(self.timerDelay)
      if (x <= 0) {
        this.timeLeft = 0
        return
      }

      setTimeout(() => {
        let newTime = this.runs.other.sendTimer[`a${this.run.id}`] - 1
        self.$store.commit('runs/setSendTimer', {
          id: self.run.id,
          time: newTime
        })
        self.timeLeft = `Waiting for reply.. (${newTime})`
        if (newTime > 0 && this.runs.other.sendTimer[`a${this.run.id}`] != 0) self.startCountdown()
        if (newTime % 5 === 0 || newTime <= 0) {
          self.getRsvpInfo(self.run.rsvpIDs[0])
        }
        if (newTime == 0) {
          this.timeLeft = 0
        }
      }, 1050)
    },
    getRsvpInfo (rsvpId) {
      let self = this
      if (!rsvpId) return
      self.$sdk.get(`/admin/rsvp/${rsvpId}`, {
        token: self.$store.state.session.sessionToken
      }, res => {
        if (!res.error) {
          if (res.provider.ID) {
            if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay)

            self.$store.commit('runs/setRunsDetails', {refresh: true})
            self.$store.commit('global/setAlertData', {
              show: true,
              message: `Driver <b>${res.provider.firstName} ${res.provider.lastName}</b> has accepted the run.`
            })
            self.timeLeft = ''
            self.$store.commit('runs/setSendTimer', {id: self.run.id, time: 0})
            self.$store.commit('runs/deleteSendTimer', self.run.id)

            // clear HERE maps
            // for (let object of self.hereMaps.map.getObjects()) {
            //   self.hereMaps.map.removeObject(object)
            // }
            // self.hereMaps.ui.getBubbles().forEach(bub => {
            //   self.hereMaps.ui.removeBubble(bub)
            // })

            // clear RUNS dropzone
            this.$store.commit('runs/clearDropzone')
          }
        }
      })
    },
    hasIssues () {
      let self = this
      if (self.inMap) {
        self.isDisabled = false
        return
      }
      if (self.dropzoneItems.length <= 0) {
        self.isDisabled = false
        return
      }
      let lastItem = self.dropzoneItems[self.dropzoneItems.length - 1]
      let rsvp = self.run.rsvps[self.run.rsvps.length - 1]
      if (rsvp.id == lastItem.id) {
        self.isDisabled = false
        return
      }
      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
      url += `&origin=${lastItem.dropoff.lat},${lastItem.dropoff.lng}`
      url += `&destination=${rsvp.pickup.lat},${rsvp.pickup.lng}`


      let eta = moment(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(lastItem.timeToNext, 'seconds')
      let nextPickup = moment(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA')
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error)
          self.isDisabled = false
          return
        }

        if (!body.routes.length) {
          return
        }
        let routeSections = body.routes[0].sections
        let etaInSec = 0
        for (let i = 0; i < routeSections.length; i++) {
          let section = routeSections[i]
          etaInSec = etaInSec + section.summary.duration
        }
        let newEta = moment(lastItem.pickupDate, 'MM/DD/YYYY hh:mmA').add(lastItem.eta, 'seconds').add(etaInSec, 'seconds')
        if (newEta.isAfter(nextPickup)) {
          self.isDisabled = true
        }
      })
      if (eta.isAfter(nextPickup)) {
        self.isDisabled = true
        return
      }
      self.isDisabled = false
      return
    }
  },
  mounted () {
  },
  watch: {
    dropzoneItems (value) {
      let self = this
      if (value.length <= 0) {
        self.isDisabled = false
        return
      }
      // self.hasIssues()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_service-types';
.dragslot {
  font-weight: 700;
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
  border: 1px solid rgba(0,0,0,0.4);
  border-radius: 3px;
}
.tr{
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  
  &.has-issues { background-color: #dddddd; }
  
  td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
  }
  input{
    margin-top: 0;
    width: 13px;
  }
  .map-pin{
    color: #fff;
    background-color: #aaa;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border-radius: 30px;
    -webkit-transition: all 250ms;
    transition: all 250ms;

    i{
      line-height: 30px;
    }
  }
  .rsvp-id{
    display: block;
    font-size: 13px;
    outline: none;
    font-weight: 600;
    line-height: 1.45;
  }
  .service-type{
    display: block;
    background: #999;
    margin-bottom: 3px;
  }
  .check {
    width: 30px;
    position: relative;

    .timer{
      position: absolute;
      bottom: 0;
      left: 0;
      white-space: nowrap;
      background: #ececec;
      padding: 3px 5px;
      line-height: 1;
      font-size: 12px;
      letter-spacing: .2px;
      color: #555;
    }
  }
  .map{ width: 40px; }
  .ids{ width: 90px; }
  .date{ width: 90px; }
  // .locs{ width: 100% }
  .driver-payment{ width: 110px; }
  .service{ width: 130px; }
}

.map-button{
  padding: 10px;

  & a{
    color: #fff;
    background-color: #aaa;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    border-radius: 30px;
    cursor: pointer;
    transition: all 250ms;

    & i {line-height: inherit;}

    &.disabled{
      pointer-events: none;
      opacity: 0.5;
      background-color: #bbb;
    }
    &.selected{
      background-color: #26D97A;
    }
  }
}

.break{
  background: #f84a4a;
  border-color: #aa4f4f;
  padding: 6px 13px 7px;

  &:hover{
    background: #cd4242;
  }
}

@media screen and (max-width: 430px) {
  .table-card {
    border: 1px solid #ccc;
    margin: 10px;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    font-size: 13px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    i {
      color: #0d79f2;
    }

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 3px;

      &.see-more {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }

    .toggle-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .toggle {
        font-size: 16px;
        color: #0e79f2;
      }
    }

    .row-1 {
      align-items: center;
      .rsvp-id {
        margin: 0 3px;
      }
      .rtg {
        display: inline-block;
        margin: 4px;
      }
      i {
        color: #26D97A;
      }
      input {
        display: inline-block;
        margin: 0;
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
      .map-button {
        padding: 0;
        a {
          background-color: #aaa;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 30px;
          -webkit-transition: all 250ms;
          transition: all 250ms;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          i {
            color: #fff;
          }
          &.disabled{
            pointer-events: none;
            opacity: 0.5;
            background-color: #bbb;
          }
          &.selected{
            background-color: #26D97A;
          }
        }
      }
    }

    .row-2 {
      display: flex;
      justify-content: unset;
      gap: 5px;
      align-items: center;
      .image {
        img {
          min-width: 30px;
          max-width: 30px;
        }
      }
    }

    .row-7 {
      strong {
        color: #666;
      }
      i {
        color: #666;
        margin: 0 3px;
      }
    }

    .row-8 {
      justify-content: center;
      .actions {
        display: flex;
        span {
          padding: 8px 20px;
        }
        .notes {
          i {
            color: #fff;
          }
        }
      }
    }

    .service-type {
      margin: 0 5px;
    }

    .clock {
      i {
        color: #F25E0D;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/RunsRow.vue